import { get } from 'mailerApi';

const urls = {
  meta: '/owners-portal/meta',
};

/**
 * @description get owners portal hostname
 * @param {string} host - owners portal hostname
 * @returns {Promise<object|Error>} - api service response
 */
const getMeta = (host) => {
  return get(`${urls.meta}/${host}`, {}, {}, true);
};

export { getMeta };
